import React, { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { fetchData, updateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import CircularProgress from '@mui/material/CircularProgress';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import SaveIcon from '@mui/icons-material/Save';
import '../Customer/Customer.css';

const RoomsEdit = ({ match }) => {
    const recordId = match.params.id;
    const history = useHistory();
    const { isAuthenticated, companyId, userId, logout, token } = useAuth();
    const [isLoading, setIsLoading] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
    }, [isAuthenticated, companyId, token, logout]);

    const [formData, setFormData] = useState({
        Name: '',
        Description: '',
        RentAmount: '',
    });

    useEffect(() => {
        fetchData('RoomApi', `/Rooms/${recordId}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    setFormData({
                        ...response.response_data,
                        UpdatedBy: userId,
                    });
                }
            })
            .catch((error) => {
                console.error('Error fetching Room Details:', error);
            });
    }, [recordId]);

    const handleChange = (event) => {
        const { name, value, type } = event.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: type === 'checkbox' ? !prevData[name] : value,
        }));
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        setIsLoading(true);

        if (!formData.Name) {
            setErrorMessage('Room Name is required!');
            setIsLoading(false);
            return;
        }

        const updatedData = {
            ...formData,
            UpdatedBy: userId,
        };

        updateData('RoomApi', `${recordId}`, updatedData, token)
            .then(() => {
                setSuccessMessage('Room updated successfully!');
                setErrorMessage('');
                history.push('/RoomIndex');
            })
            .catch((error) => {
                console.error('Error updating record:', error);
                setErrorMessage('Failed to update room.');
                setIsLoading(false);
            });
    };

    return (
        <div className="form-container">
            <div className="form-card">
                {/* Header */}
                <div className="form-header">
                    <h1 className="form-title">Edit Room</h1>
                    <div className="form-actions">
                        <Link to="/RoomIndex" className="btn-back">
                            <ArrowBackIcon fontSize="small" />
                            Back to List
                        </Link>
                        <button className="btn-save" onClick={handleSubmit} disabled={isLoading}>
                            {isLoading ? (
                                <CircularProgress size={18} color="inherit" />
                            ) : (
                                <>
                                    <SaveIcon fontSize="small" />
                                    Update
                                </>
                            )}
                        </button>
                    </div>
                </div>

                {/* Messages */}
                {errorMessage && <div className="message error">{errorMessage}</div>}
                {successMessage && <div className="message success">{successMessage}</div>}

                {/* Form Body */}
                <div className="form-body">
                    <div className="form-row">
                        <div className="form-group">
                            <label className="form-label">Room Name / No. *</label>
                            <input
                                className="form-input"
                                value={formData.Name || ''}
                                onChange={handleChange}
                                name="Name"
                                type="text"
                                placeholder="Enter Room Name/No."
                            />
                        </div>
                        <div className="form-group" style={{ flex: 2 }}>
                            <label className="form-label">Description</label>
                            <input
                                className="form-input"
                                value={formData.Description || ''}
                                onChange={handleChange}
                                name="Description"
                                type="text"
                                placeholder="Enter Description"
                            />
                        </div>
                        <div className="form-group">
                            <label className="form-label">Rent Amount *</label>
                            <input
                                className="form-input"
                                value={formData.RentAmount || ''}
                                onChange={handleChange}
                                name="RentAmount"
                                type="number"
                                placeholder="Enter Rent Amount"
                                style={{ textAlign: 'right' }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RoomsEdit;
